import { Big } from 'big.js';

export const DEMO_COMMERCIAL_HOURLY_RATE = 400;
export const DEMO_COMMERCIAL_MINIMUM_MINUTES = 0;

export function DEMO_COMMERCIAL_COST(minutes: number) {
  return new Big(Math.ceil(minutes / 10) * 10).div(60).times(DEMO_COMMERCIAL_HOURLY_RATE);
}
